var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "drop_arrow",
    "data-name": "drop arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H14V8H0Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H14V8H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop_arrow-2",
    "data-name": "drop arrow",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M.962.175a.542.542,0,0,0-.8,0,.62.62,0,0,0,0,.842L6.6,7.825a.542.542,0,0,0,.8,0l6.437-6.809a.62.62,0,0,0,0-.842.542.542,0,0,0-.8,0L7,6.384Z",
    transform: "translate(0 0)",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropArrow);
export default __webpack_public_path__ + "static/media/icon_drop_arrow.f87495f8e3461c68616c66c6b02eb460.svg";
export { ForwardRef as ReactComponent };